import "./HomePage.css";
import HeadlineArea from "./HeadlineArea";
import BenefitsCards from "./BenefitsCards";
import PublishingMethodsCards from "./PublishingMethodsCards";
import PublishingProcessSteps from "./PublishingProcessSteps";
import AuthorPortalSection from "./AuthorPortalSection";
import ReviewsSection from "./ReviewsSection";
import BooksPublishedSection from "./BooksPublishedSection";
import FAQSection from "./FAQSection";
import AnnouncementSection from "./AnnouncementSection";
// import GetStartedSection from "./GetStartedSection";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../../Footer";

const HomePage = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollToFAQ) {
      setTimeout(() => {
        const faqHeader = document.querySelector(".faq-section-header");

        if (faqHeader) {
          faqHeader.scrollIntoView({
            // behavior: "smooth",
            // block: "start",
          });
        }

        window.history.replaceState({}, document.title);
      }, 0);
    }
  }, [location]);

  return (
    <div className="home-page-content">
      <HeadlineArea />
      <BenefitsCards />
      <PublishingMethodsCards />
      <PublishingProcessSteps />
      <BooksPublishedSection />
      <AuthorPortalSection />
      <ReviewsSection />
      <FAQSection />
      {/* <AnnouncementSection /> */}
      <Footer />
    </div>
  );
};
export default HomePage;
